module.exports = __webpack_public_path__ + "pinturasolidaria.jpg?54aac68aa3fc3e5981c39b6c446d2a6e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/pinturasolidaria.jpg
// module id = 146
// module chunks = 0